import { Box } from "@chakra-ui/react";

const Card = ({
    children,
    p = 6,
    ...props
}) => {
    return (
        <Box
            bg="white"
            borderRadius="20px"
            border="1px solid"
            borderColor="gray.200"
            boxShadow="0 6px 18px rgba(15,23,42,.05)"
            p={p}
            {...props}
        >
            {children}
        </Box>
    );
};

export default Card;